import { Action } from 'redux';

import { UpdateAlertTotal } from '../../app/actions/AppActionTypes';
import { isActionFactory } from '../../app/actions/isActionFactory';

export interface UpdateAlertTotalAction extends Action {
  total: number;
}

export function updateAlertTotalAction(total: number): UpdateAlertTotalAction {
  return {
    type: UpdateAlertTotal,
    total: total
  };
}

export const isUpdateAlertTotalAction = isActionFactory<UpdateAlertTotalAction>(UpdateAlertTotal);
